// Catálogo y ficha de vehículos (listado, filtros, tarjetas, orden, ficha, galería) y valores de catálogo de la base — English (US). Mismas claves que es/catalog.ts.
//
// `values`: etiquetas en inglés de los VALORES que la base guarda en español
// (condición, combustible, transmisión, categoría, color). Hoy sólo se consultan
// en sitios de Brasil (`etiquetaCatalogoPt`); están por paridad de claves.
export const catalogEn = {
  common: {
    vehicle: 'Vehicle',
  },
  listing: {
    loadMore: 'Show more vehicles',
    viewAll: 'View all vehicles',
    clearSearch: 'Clear search',
  },
  search: {
    tip: 'Try: "under $15,000", "no diesel", "with sunroof"',
    noResultsFor: 'We couldn\'t find any vehicles for "{{query}}"',
    didYouMean: 'Did you mean?',
    tipsTitle: 'Smart search tips',
    tipPrice: '"under $15,000"',
    tipPriceDesc: ' - Filters by maximum price',
    tipYear: '"2020 or newer"',
    tipYearDesc: ' - Filters by minimum year',
    tipFuel: '"no diesel"',
    tipFuelDesc: ' - Excludes a fuel type',
    tipFeature: '"with sunroof"',
    tipFeatureDesc: ' - Searches by features',
  },
  filters: {
    expand: 'Expand filters',
    collapse: 'Collapse filters',
    priceRangeAria: 'Price range',
    yearFrom: 'From',
    yearTo: 'To',
    anyYear: 'Any',
  },
  promo: {
    limitedTime: 'Limited time',
    countOne: 'car on sale',
    countMany: 'cars on sale',
  },
  card: {
    new: 'New',
    recentArrival: 'Just arrived',
    opportunity: 'Great deal',
    featured: 'Featured',
    save: 'Save',
    cashPrice: 'Cash price',
    financingPrice: 'Financing price',
  },
  detail: {
    viewGallery: 'View full gallery',
    shareText: 'Check out this {{title}}',
    linkCopied: 'Link copied!',
    copyError: "Couldn't copy the link",
    whatsappMessage: "Hi, I'm interested in the {{vehicle}} I saw at {{url}}",
    availableAt: 'Available at location',
    directions: 'Get directions',
    unsave: 'Remove from saved',
  },
  gallery: {
    close: 'Close',
    previous: 'Previous',
    next: 'Next',
    exitZoom: 'Exit zoom',
  },
  values: {
    condition: {
      nuevo: 'New',
      semi_nuevo: 'Nearly new',
      seminuevo: 'Nearly new',
      usado: 'Used',
    },
    fuel: {
      gasolina: 'Gasoline',
      bencina: 'Gasoline',
      diesel: 'Diesel',
      hibrido: 'Hybrid',
      electrico: 'Electric',
      flex: 'Flex fuel',
      gnv: 'CNG',
      etanol: 'Ethanol',
      gas: 'LPG',
    },
    transmission: {
      manual: 'Manual',
      automatica: 'Automatic',
    },
    category: {
      suv: 'SUV',
      sedan: 'Sedan',
      camioneta: 'Truck',
      deportivo: 'Sports car',
      clasico: 'Classic',
      coupe: 'Coupe',
      furgon: 'Cargo van',
      camion_rigido: 'Straight Truck',
      tractocamion: 'Semi Truck',
      camion_tolva: 'Dump Truck',
      camion_pluma: 'Crane Truck',
      camion_cisterna: 'Tanker Truck',
      camion_frigorifico: 'Refrigerated Truck',
      camion_plataforma: 'Flatbed Truck',
      camion_portacontenedores: 'Container Truck',
      bus: 'Bus',
      minibus: 'Minibus',
      excavadora: 'Excavator',
      retroexcavadora: 'Backhoe Loader',
      cargador_frontal: 'Front Loader',
      bulldozer: 'Bulldozer',
      hatchback: 'Hatchback',
      motoniveladora: 'Motor Grader',
      rodillo_compactador: 'Compactor Roller',
      minicargador: 'Skid Steer',
      mini_excavadora: 'Mini Excavator',
      grua: 'Crane',
      manipulador_telescopico: 'Telehandler',
      tractor_agricola: 'Farm Tractor',
      cosechadora: 'Combine Harvester',
      camion_articulado: 'Articulated Truck',
      generador: 'Generator',
      pickup: 'Pickup',
      compresor: 'Compressor',
      montacargas: 'Forklift',
      plataforma_elevadora: 'Aerial Work Platform',
      lancha: 'Motorboat',
      moto_de_agua: 'Personal Watercraft',
      velero: 'Sailboat',
      yate: 'Yacht',
      bote_inflable: 'Inflatable Boat',
      semirrigido: 'RIB',
      ponton: 'Pontoon',
      van: 'Van',
      crucero: 'Cruiser',
      catamaran: 'Catamaran',
      kayak: 'Kayak',
      motor_fuera_de_borda: 'Outboard Motor',
      lancha_de_pesca: 'Fishing Boat',
      city_car: 'City Car',
      minivan: 'Minivan',
      station_wagon: 'Station Wagon',
      crossover: 'Crossover',
      moto: 'Motorcycle',
      automovil: 'Car',
      camion: 'Heavy Truck',
      micro_bus: 'Minibus',
      cabezal: 'Semi Tractor',
      limusina: 'Limousine',
      buggy: 'Buggy',
      motorhome: 'Motorhome',
      ambulancia: 'Ambulance',
      cuatriciclo: 'ATV',
      triciclo: 'Trike',
      wagon: 'Wagon',
      kart: 'Go-Kart',
      bote: 'Boat',
      jet_ski: 'Jet Ski',
      maquinaria: 'Machinery',
      otro: 'Other',
      vehiculos_de_trabajo: 'Work vehicles',
      moto_atv_y_utv: 'Motorcycle, ATV & UTV',
      convertible: 'Convertible',
    },
    color: {
      amarillo: 'Yellow',
      azul: 'Blue',
      azul_oscuro: 'Dark Blue',
      beige: 'Beige',
      blanco: 'White',
      borgona: 'Burgundy',
      burdeo: 'Burgundy',
      cafe: 'Brown',
      celeste: 'Light Blue',
      cobre: 'Copper',
      dorado: 'Gold',
      gris: 'Gray',
      gris_claro: 'Light gray',
      gris_oscuro: 'Dark gray',
      gris_plata: 'Silver Gray',
      morado: 'Purple',
      naranja: 'Orange',
      naranjo: 'Orange',
      negro: 'Black',
      plata: 'Silver',
      plateado: 'Silver',
      rojo: 'Red',
      rosado: 'Pink',
      terracota: 'Terracotta',
      turquesa: 'Turquoise',
      verde: 'Green',
      verde_claro: 'Light green',
      verde_oscuro: 'Dark green',
      violeta: 'Violet',
    },
  },
};
